let content = {
    landing: {
        title: "Sciences en scène",
    },
    paragraph1: {
        title: "Les défis de la communication scientifique",
        content:
            "Le système universitaire, et ce qu’on appelle la culture du « publish-or-perish » laisse peu de temps aux universitaires pour diffuser leurs travaux. En tant que scientifique, il est souvent difficile de partager ses recherches avec le grand public. De plus, les stéréotypes liés aux scientifiques les présentent souvent comme des personnes froides et inaccessibles. Sans compter qu’il existe encore peu de moyens mis au service d’une diffusion créative des travaux de recherche.",
    },
    hero1: {
        title: "Notre solution",
    },
    paragraph2: {
        title: "Chaque spectacle est improvisé, donc unique.",
        content:
            "Sciences en Scène utilise l’improvisation théâtrale comme moyen d’informer et de sensibiliser le grand public sur la recherche. Nous extrayons vos travaux du laboratoire pour leur donner vie sur scène. Nous créons un spectacle sur-mesure qui s’articule autour de votre recherche (votre pitch, vos publications, votre routine de travail, etc.) dans le but d’en vulgariser le bagage scientifique et d’en transmettre la réalité quotidienne à une large audience.",
    },
}

export default content
